module.exports = "<modal class=modal--iframe> <modal-header> <h1 ng-if=$ctrl.title>{{$ctrl.title}}</h1> <modal-close ng-click=$ctrl.onClose()></modal-close> </modal-header> <modal-content> <iframe ng-src={{$ctrl.link}} frameborder=0></iframe> </modal-content> </modal> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-iframe/modal-iframe.template.html
// module id = 561
// module chunks = 0